import { render, staticRenderFns } from "./AvatarUploadPreview.vue?vue&type=template&id=b7a622bc&scoped=true&"
import script from "./AvatarUploadPreview.vue?vue&type=script&lang=ts&"
export * from "./AvatarUploadPreview.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarUploadPreview.vue?vue&type=style&index=0&id=b7a622bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a622bc",
  null
  
)

export default component.exports